import { useState, useEffect } from "react";
import { NavLink, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";
import { Button } from "@/components/ui/button";
import {
  LayoutDashboard, Calendar, Inbox, Users, Car, Sparkles, FileText,
  Receipt, Wallet, TrendingDown, Landmark, BarChart3, FolderOpen,
  Settings as SettingsIcon, LogOut, Menu, ShieldCheck, FileCheck, CreditCard,
  Image as ImageIcon, MessageSquare, UserPlus, Repeat, AlertTriangle, Truck, Gift, Bell,
  Mail, MessageCircle, Bot, Megaphone, Route as RouteIcon, BookUser, Ticket, CalendarClock, UserCheck, Package, PieChart, Wrench, Trash2,
  Sun, CheckSquare, Boxes, Sprout, MessageSquareText, SlidersHorizontal, QrCode, Smartphone, FileSignature, Undo2, ChevronDown,
} from "lucide-react";
import GlobalSearch from "@/components/GlobalSearch";
import NotificationBell from "@/components/NotificationBell";
import { useProfile, moduleEnabled } from "@/context/BusinessProfileContext";
import OfflineBanner from "@/components/OfflineBanner";

const NAV = [
  { to: "/dashboard", label: "Tableau de bord", icon: LayoutDashboard, testid: "dashboard", m: "dashboard" },
  { to: "/today", label: "Aujourd'hui", icon: Sun, testid: "today", m: "today" },
  { to: "/calendar", label: "Agenda", icon: Calendar, testid: "calendar", m: "calendar", voc: "appointment_plural" },
  { to: "/taches", label: "Tâches", icon: CheckSquare, testid: "tasks", m: "tasks" },
  { to: "/requests", label: "Demandes RDV", icon: Inbox, testid: "requests", m: "requests" },
  { to: "/prospects", label: "Prospects", icon: UserPlus, testid: "prospects", m: "prospects" },
  { to: "/clients", label: "Clients", icon: Users, testid: "clients", m: "clients" },
  { to: "/relances", label: "Clients à relancer", icon: UserCheck, testid: "relances", m: "relances" },
  { to: "/vehicles", label: "Véhicules", icon: Car, testid: "vehicles", m: "vehicles", voc: "object_plural" },
  { to: "/services", label: "Prestations", icon: Sparkles, testid: "services", m: "services", voc: "service_plural" },
  { to: "/stock", label: "Stock & produits", icon: Package, testid: "stock", m: "stock" },
  { to: "/contrats", label: "Contrats", icon: Repeat, testid: "contracts", m: "contracts" },
  { to: "/interventions-recurrentes", label: "Interventions récurrentes", icon: CalendarClock, testid: "recurring-appts", m: "recurring_appts" },
  { to: "/ressources", label: "Ressources", icon: Boxes, testid: "resources", m: "resources" },
  { to: "/page-reservation", label: "Page de réservation", icon: CalendarClock, testid: "booking", m: "booking" },
  { to: "/quotes", label: "Devis", icon: FileText, testid: "quotes", m: "quotes" },
  { to: "/invoices", label: "Factures", icon: Receipt, testid: "invoices", m: "invoices" },
  { to: "/avoirs", label: "Acomptes & avoirs", icon: Undo2, testid: "avoirs", m: "invoices" },
  { to: "/bons", label: "Bons d'intervention", icon: FileSignature, testid: "bons", m: "intervention_reports" },
  { to: "/terrain", label: "Mode Terrain", icon: Smartphone, testid: "field-mode", m: "field_mode" },
  { to: "/qr-codes", label: "QR codes", icon: QrCode, testid: "qr", m: "booking" },
  { to: "/factures-recurrentes", label: "Factures récurrentes", icon: Repeat, testid: "recurring", m: "recurring" },
  { to: "/impayes", label: "Relances impayés", icon: AlertTriangle, testid: "unpaid", m: "unpaid" },
  { to: "/facturation-electronique", label: "Facturation électronique", icon: FileCheck, testid: "einvoicing", m: "einvoicing" },
  { to: "/payments", label: "Encaissements", icon: Wallet, testid: "payments", m: "payments" },
  { to: "/fournisseurs", label: "Fournisseurs / Achats", icon: Truck, testid: "suppliers", m: "suppliers" },
  { to: "/comptabilite", label: "Comptabilité", icon: Landmark, testid: "comptabilite", m: "comptabilite" },
  { to: "/expenses", label: "Dépenses", icon: TrendingDown, testid: "expenses", m: "expenses" },
  { to: "/frais-deplacement", label: "Frais de déplacement", icon: RouteIcon, testid: "deplacements", m: "deplacements" },
  { to: "/croissance", label: "Croissance", icon: Sprout, testid: "growth", m: "loyalty" },
  { to: "/notifications", label: "Notifications", icon: Bell, testid: "notifications", m: "notifications" },
  { to: "/mes-emails", label: "Mes emails", icon: Mail, testid: "mes-emails", m: "emails" },
  { to: "/mes-sms", label: "Mes SMS", icon: MessageCircle, testid: "mes-sms", m: "sms" },
  { to: "/modeles-messages", label: "Modèles de messages", icon: MessageSquareText, testid: "comm-templates", m: "comm_templates" },
  { to: "/marketing", label: "Marketing", icon: Megaphone, testid: "marketing", m: "marketing" },
  { to: "/assistant-ia", label: "Assistant IA", icon: Bot, testid: "assistant-ia", m: "assistant" },
  { to: "/galerie", label: "Galerie", icon: ImageIcon, testid: "galerie", m: "galerie" },
  { to: "/cheques-cadeaux", label: "Chèques cadeaux", icon: Gift, testid: "giftcards", m: "giftcards" },
  { to: "/roue", label: "Roue de la fortune", icon: Ticket, testid: "roue", m: "roue" },
  { to: "/annuaire", label: "Annuaire des pros", icon: BookUser, testid: "annuaire", m: "annuaire" },
  { to: "/chat", label: "Chat communautaire", icon: MessageSquare, testid: "chat", m: "chat" },
  { to: "/stats", label: "Statistiques", icon: BarChart3, testid: "stats", m: "stats" },
  { to: "/analytics", label: "Analytics métier", icon: PieChart, testid: "analytics", m: "analytics" },
  { to: "/outils-detailing", label: "Outils Detailing", icon: Boxes, testid: "detailing-tools", m: "detailing_tools" },
  { to: "/suivi-protections", label: "Suivi des protections", icon: ShieldCheck, testid: "protections-tracking", m: "detailing_tools" },
  { to: "/outils", label: "Outils & données", icon: Wrench, testid: "outils", m: "outils" },
  { to: "/corbeille", label: "Corbeille", icon: Trash2, testid: "corbeille", m: "corbeille" },
  { to: "/documents", label: "Documents", icon: FolderOpen, testid: "documents", m: "documents" },
  { to: "/configuration", label: "Mon métier & modules", icon: SlidersHorizontal, testid: "configuration", m: "__core__" },
  { to: "/settings", label: "Paramètres", icon: SettingsIcon, testid: "settings", m: "__core__" },
  { to: "/parametres/notifications", label: "Préf. notifications", icon: Bell, testid: "notif-settings", m: "__core__" },
];

function navLabel(item, vocab) {
  if (item.voc === "object_plural") return vocab.object_plural || item.label;
  if (item.voc === "service_plural") return (vocab.service ? vocab.service + "s" : item.label);
  if (item.voc === "appointment_plural") return vocab.appointment ? `Agenda · ${vocab.appointment}${/[sxz]$/i.test(vocab.appointment) ? "" : "s"}` : item.label;
  return item.label;
}

const GROUPS = [
  ["activite", "Activité", ["today", "calendar", "tasks", "requests", "field-mode"]],
  ["clients", "Clients & activité commerciale", ["prospects", "clients", "relances", "vehicles", "services", "contracts", "recurring-appts", "resources", "booking"]],
  ["facturation", "Devis & facturation", ["quotes", "invoices", "avoirs", "bons", "recurring", "unpaid", "einvoicing", "payments"]],
  ["gestion", "Gestion", ["stock", "suppliers", "comptabilite", "expenses", "deplacements", "documents"]],
  ["com", "Communication & marketing", ["notifications", "mes-emails", "mes-sms", "comm-templates", "marketing", "assistant-ia", "galerie", "giftcards", "roue", "annuaire", "chat"]],
  ["analyse", "Analyse & outils métier", ["stats", "analytics", "detailing-tools", "protections-tracking", "outils", "growth", "qr"]],
  ["config", "Configuration", ["corbeille", "configuration", "settings", "notif-settings", "equipe", "abonnement", "superadmin"]],
];
const OPEN_KEY = "ced_nav_open";

function NavItem({ item, vocabulary, onNavigate, unread, top }) {
  return (
    <NavLink
      to={item.to}
      onClick={onNavigate}
      data-testid={`sidebar-nav-${item.testid}`}
      className={({ isActive }) =>
        `group flex items-center gap-3 px-3 ${top ? "py-3 font-semibold" : "py-2.5"} rounded-md text-sm transition-colors duration-150 ${
          isActive
            ? "bg-emerald-500/10 text-emerald-600 border-l-2 border-emerald-500 font-medium"
            : `${top ? "text-slate-800" : "text-slate-500"} hover:text-slate-900 hover:bg-slate-100 border-l-2 border-transparent`
        }`
      }
    >
      <item.icon className="w-[18px] h-[18px] shrink-0" />
      <span className="flex-1">{navLabel(item, vocabulary)}</span>
      {item.testid === "chat" && unread > 0 && (
        <span data-testid="chat-unread-badge" className="text-[10px] font-bold min-w-[18px] h-[18px] px-1 rounded-full bg-red-500 text-white flex items-center justify-center shrink-0">
          {unread > 99 ? "99+" : unread}
        </span>
      )}
    </NavLink>
  );
}

function NavList({ onNavigate, unread = 0 }) {
  const { user } = useAuth();
  const { modules, vocabulary } = useProfile();
  const extra = [];
  if (user && ["owner", "admin"].includes(user.role)) extra.push({ to: "/equipe", label: "Équipe", icon: Users, testid: "equipe", m: "__core__" });
  if (user?.role === "owner") extra.push({ to: "/abonnement", label: "Mon abonnement", icon: CreditCard, testid: "abonnement", m: "__core__" });
  if (user?.is_super_admin) extra.push({ to: "/super-admin", label: "Super Admin", icon: ShieldCheck, testid: "superadmin", m: "__core__" });
  const items = [...NAV, ...extra].filter((it) => it.m === "__core__" || it.testid === "dashboard" || moduleEnabled(modules, it.m));
  const byId = Object.fromEntries(items.map((i) => [i.testid, i]));
  const location = useLocation();
  const [open, setOpen] = useState(() => { try { return JSON.parse(localStorage.getItem(OPEN_KEY) || "{}"); } catch { return {}; } });
  const toggle = (k) => { const n = { ...open, [k]: !open[k] }; setOpen(n); localStorage.setItem(OPEN_KEY, JSON.stringify(n)); };
  const placed = new Set(["dashboard", ...GROUPS.flatMap((g) => g[2])]);
  const groups = GROUPS.map(([k, label, ids]) => [k, label, ids.map((id) => byId[id]).filter(Boolean)]);
  const rest = items.filter((i) => !placed.has(i.testid));
  if (rest.length) groups[groups.length - 1][2].push(...rest);
  return (
    <nav className="flex flex-col gap-1 flex-1 overflow-y-auto ced-scroll-thin pr-1">
      {byId.dashboard && <NavItem item={byId.dashboard} vocabulary={vocabulary} onNavigate={onNavigate} unread={unread} top />}
      {groups.filter((g) => g[2].length).map(([k, label, list]) => {
        const active = list.some((i) => location.pathname === i.to || location.pathname.startsWith(i.to + "/"));
        const isOpen = open[k] ?? active;
        return (
          <div key={k} className="mt-1">
            <button type="button" onClick={() => toggle(k)} data-testid={`nav-group-${k}`} aria-expanded={isOpen}
              className="w-full flex items-center justify-between px-3 py-2.5 rounded-md text-[11px] font-bold uppercase tracking-wider text-slate-400 hover:text-slate-700 hover:bg-slate-50">
              <span className="text-left">{label}</span>
              <ChevronDown className={`w-4 h-4 shrink-0 transition-transform ${isOpen ? "rotate-180" : ""}`} />
            </button>
            {isOpen && <div className="flex flex-col gap-0.5 mt-0.5" data-testid={`nav-group-items-${k}`}>{list.map((item) => <NavItem key={item.to} item={item} vocabulary={vocabulary} onNavigate={onNavigate} unread={unread} />)}</div>}
          </div>
        );
      })}
    </nav>
  );
}

function Brand() {
  return (
    <div className="flex items-center gap-2.5 px-1 mb-6">
      <div className="w-9 h-9 rounded-lg bg-emerald-500 flex items-center justify-center shrink-0">
        <ShieldCheck className="w-5 h-5 text-black" />
      </div>
      <div className="leading-tight">
        <div className="font-heading font-extrabold text-slate-900 text-[15px] tracking-tight">Auto Detail Manager</div>
        <div className="text-[10px] uppercase tracking-widest text-emerald-600/80">ADM · SaaS Detailing</div>
      </div>
    </div>
  );
}

export default function Layout({ children }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const [unread, setUnread] = useState(0);

  useEffect(() => {
    if (location.pathname === "/chat") { setUnread(0); return; }
    let active = true;
    const fetchUnread = async () => {
      try { const { data } = await api.get("/chat/unread-count"); if (active) setUnread(data.count || 0); } catch { /* ignore */ }
    };
    fetchUnread();
    const t = setInterval(fetchUnread, 20000);
    return () => { active = false; clearInterval(t); };
  }, [location.pathname]);

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  const UserBox = (
    <div className="border-t border-slate-200 pt-3 mt-3">
      <div className="flex items-center gap-3 px-1 mb-2">
        <div className="w-8 h-8 rounded-full bg-emerald-500/20 text-emerald-600 flex items-center justify-center text-xs font-semibold">
          {(user?.name || "?").slice(0, 2).toUpperCase()}
        </div>
        <div className="min-w-0">
          <div className="text-xs font-medium text-slate-700 truncate">{user?.name}</div>
          <div className="text-[10px] text-slate-500 truncate">{user?.role === "owner" ? "Propriétaire" : user?.role === "admin" ? "Administrateur" : "Employé"}</div>
        </div>
      </div>
      <Button
        variant="ghost"
        onClick={handleLogout}
        data-testid="btn-logout"
        className="w-full justify-start text-slate-500 hover:text-red-600 hover:bg-red-500/10 h-9"
      >
        <LogOut className="w-4 h-4 mr-2" /> Déconnexion
      </Button>
    </div>
  );

  return (
    <div className="min-h-screen bg-slate-50 text-slate-700">
      {/* Desktop sidebar */}
      <aside className="hidden lg:flex flex-col fixed left-0 top-0 bottom-0 w-64 bg-white border-r border-slate-200 p-4 z-40 shadow-sm">
        <Brand />
        <div className="flex justify-end -mt-4 mb-1"><NotificationBell /></div>
        <NavList unread={unread} />
        {UserBox}
      </aside>

      {/* Mobile top bar */}
      <header className="lg:hidden sticky top-0 z-40 flex items-center justify-between px-4 h-14 bg-white border-b border-slate-200 shadow-sm">
        <div className="flex items-center gap-2">
          <div className="w-7 h-7 rounded-md bg-emerald-500 flex items-center justify-center">
            <ShieldCheck className="w-4 h-4 text-black" />
          </div>
          <span className="font-heading font-bold text-slate-900 text-sm">Auto Detail Manager</span>
        </div>
        <div className="flex-1" />
        <GlobalSearch compact />
        <NotificationBell />
        <Sheet open={open} onOpenChange={setOpen}>
          <SheetTrigger asChild>
            <Button variant="ghost" size="icon" data-testid="btn-mobile-menu" className="text-slate-700">
              <Menu className="w-6 h-6" />
            </Button>
          </SheetTrigger>
          <SheetContent side="left" className="bg-white border-slate-200 w-72 flex flex-col p-4">
            <Brand />
            <NavList onNavigate={() => setOpen(false)} unread={unread} />
            {UserBox}
          </SheetContent>
        </Sheet>
      </header>

      <main className="lg:pl-64">
        <OfflineBanner />
        <div className="hidden lg:block sticky top-0 z-30 bg-slate-50/90 backdrop-blur border-b border-slate-200">
          <div className="max-w-[1400px] mx-auto px-8 py-3 flex justify-end">
            <div className="w-96"><GlobalSearch /></div>
          </div>
        </div>
        <div className="p-4 sm:p-6 lg:p-8 max-w-[1400px] mx-auto">{children}</div>
      </main>
    </div>
  );
}
